import { useState, useEffect } from "react";

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < breakpoint || window.location.pathname === "/signin"
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint || window.location.pathname === "/signin");
    };

    const handleRouteChange = () => {
      setIsMobile(window.innerWidth < breakpoint || window.location.pathname === "/signin");
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("popstate", handleRouteChange); // ✅ Detects URL changes

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
